import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

export default class ErrorModal extends Component {
    render() {
        const { show, handleClose } = this.props;
        return (
            <Modal
                animation={false}
                show={show}
                onHide={handleClose}
                className="modal"
                dialogClassName="modal-lg modal-dialog-centered"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-400 fs-14">Erro</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                  <div className="alert alert-danger rounded-0 mb-0">
                    Usuário não possui permissão para realizar essa ação.
                  </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-danger btn-outline" onClick={handleClose}>Fechar</button>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/Enable/ErrorModal.js